import { BrowserRouter } from "react-router-dom";
import Layout from "./components/global/Layout";
import MainRoutes from "./routes";

const App = () => {
    return (
        <BrowserRouter>
            <Layout>
                <MainRoutes />
            </Layout>
        </BrowserRouter>
    );
};

export default App;
